import createHistory from "history/createBrowserHistory";
import { Router as BrowserRouter, StaticRouter } from "react-router-dom";
var Router = typeof window !== "undefined" ? BrowserRouter : StaticRouter;
var getProps = function (_a) {
    var location = _a.location;
    return typeof window !== "undefined" ? {
        history: createHistory(),
    } : {
        context: {},
        location: location,
    };
};
export { Router, getProps };



//////////////////
// WEBPACK FOOTER
// ./app/shared/components/router.tsx
// module id = H7tR
// module chunks = 2 3 4